// extracted by mini-css-extract-plugin
module.exports = {"loader":"onfido-sdk-ui-Spinner-loader","inner":"onfido-sdk-ui-Spinner-inner","ball-scale-ripple-multiple":"onfido-sdk-ui-Spinner-ball-scale-ripple-multiple"};